import axios from 'axios';
import ServerProperties from '../../../../config/server.js'
import {SuperADODB} from '../../../request.action.js'
export default {
  Read: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.AuthorizationToken;
    axios.get(
        ServerProperties.ATM_CLOUD.API+'Master/Currencies/',
      {
      }
    )
    .then(function (response) {
      params.RunRedux(SuperADODB("CurrencySetRS",response.data))
    })
    .catch(function (error) {
      console.error("failed on read currency");
    });
  },
}



// WEBPACK FOOTER //
// ./src/App/helper/ADODB/super/currency/model.js